export default import.meta.ROLLUP_FILE_URL_CMkY$$7u;